import React, { forwardRef } from 'react';
interface InputProps extends InputHTMLAttributes<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement> {
  label?: string;
  error?: string;
  helperText?: string;
  as?: 'input' | 'textarea' | 'select';
  options?: {
    label: string;
    value: string;
  }[];
}
export const Input = forwardRef<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement, InputProps>(({
  label,
  error,
  helperText,
  className = '',
  as = 'input',
  options,
  ...props
}, ref) => {
  const baseStyles = 'w-full rounded-xl border border-pastel-grey bg-white px-4 py-3 text-sm transition-all focus:border-dark focus:outline-none focus:ring-1 focus:ring-dark disabled:cursor-not-allowed disabled:bg-pastel-grey-light';
  const errorStyles = error ? 'border-red-500 focus:border-red-500 focus:ring-red-500' : '';
  const inputClasses = `${baseStyles} ${errorStyles} ${className}`;
  return <div className="w-full space-y-1.5" data-id="element-48">
        {label && <label className="block text-sm font-medium text-[#7C1A32]" data-id="element-49">
            {label}
          </label>}

        {as === 'textarea' ? <textarea ref={ref as React.Ref<HTMLTextAreaElement>} className={`${inputClasses} min-h-[100px] resize-y`} {...props as React.TextareaHTMLAttributes<HTMLTextAreaElement>} data-id="element-50" /> : as === 'select' ? <select ref={ref as React.Ref<HTMLSelectElement>} className={inputClasses} {...props as React.SelectHTMLAttributes<HTMLSelectElement>} data-id="element-51">
            <option value="" disabled data-id="element-52">
              Pilih opsi
            </option>
            {options?.map(opt => <option key={opt.value} value={opt.value} data-id="element-53">
                {opt.label}
              </option>)}
          </select> : <input ref={ref as React.Ref<HTMLInputElement>} className={inputClasses} {...props as React.InputHTMLAttributes<HTMLInputElement>} data-id="element-54" />}

        {error && <p className="text-sm text-red-500 mt-1" data-id="element-55">{error}</p>}
        {helperText && !error && <p className="text-sm text-gray-500 mt-1" data-id="element-56">{helperText}</p>}
      </div>;
});
Input.displayName = 'Input';